import { getDomain } from 'tldts';
import { z } from 'zod';
import { domainSummarySchema, type DnsRecord } from './domains.ts';

export const dnsCardSchema = z.object({
  type: z.literal('DnsRecords'),
  capturedAt: z.iso.datetime().meta({ pattern: undefined }),
  domain: domainSummarySchema,
});

export function shortDnsName(name: string, domain: string): string {
  const hostname = domain.split(':')[0]!.replace(/\.$/, '').toLowerCase();
  const zone = getDomain(hostname, { allowPrivateDomains: true }) ?? hostname;
  const fullName = name.replace(/\.$/, '');
  if (fullName.toLowerCase() === zone) return '@';
  return fullName.toLowerCase().endsWith(`.${zone}`) ? fullName.slice(0, -(zone.length + 1)) : name;
}

export function dnsValueFields(record: DnsRecord): { label: string; value: string }[] {
  if (record.type === 'SVCB') {
    const parts = /^\s*(\d+)\s+(\S+)(?:\s+([\s\S]*?))?\s*$/.exec(record.value);
    return [
      ...(parts && Number(parts[1]) <= 65535
        ? [
            { label: 'Priority', value: parts[1]! },
            { label: 'Target', value: parts[2]! },
            { label: 'Parameters', value: parts[3] ?? '' },
          ]
        : []),
      { label: 'Complete value', value: record.value },
    ];
  }
  const labels = { A: 'IPv4 address', TXT: 'Text value' };
  return [{ label: labels[record.type], value: record.value }];
}
